<template>
  <div class="container-update">
    <div class="alert-content">
      <i class="fas fa-cloud-download-alt"></i>
      <h3>{{ $t("updating.title") }} {{ value }}</h3>
      <p class="w-60 mx-auto">{{ $t("updating.message") }} </p>
      <button class="update-button" @click="performUpdate">
        {{ $t("updating.button")}}     
      </button>
    </div>
  </div>
</template>
<script>
import { logoutUser } from "@/utils/auth";


export default {
  name: "Updating-View",
  props: {
    newVersion: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showMobileAlert: false,
      value:localStorage.getItem("app_version")
    };
  },
  created() {
     
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    
    performUpdate() {
      // Mise à jour des service workers
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          for (let registration of registrations) {
            registration.update();
          }
        });
      }
      
      // Nettoyage du cache si l'API Cache est disponible
      if ('caches' in window) {
        caches.keys().then(cacheNames => {
          cacheNames.forEach(cacheName => {
            caches.delete(cacheName);
          });
        });
      }
        localStorage.setItem("app_version", this.newVersion);
      // Attendre un court instant pour que les opérations de cache se terminent
      setTimeout(() => {
        logoutUser();  
         window.location.reload(true);
      }, 300);
    },
  },
  }

</script>

<style scoped>
.container-update{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #111c44;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  pointer-events: auto;
  overflow: hidden;
}
.alert-content {
  padding: 2rem;
  max-width: 90%;
}
.alert-content i {
  font-size: 4rem;
  color: #75acff;
  margin-bottom: 1rem;
}
.alert-content h3 {
  color:#fff;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}
.alert-content p {
  color: #fff;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}
.update-button {
  background: #75acff;
  color: #00182b;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.update-button:hover {
   background: #91b9f5;
}
</style>
